import { useEffect, useState } from "react";

export interface AppRoute {
  path: string;
  search: URLSearchParams;
}

function normalizeHash(hash: string): string {
  const withoutHash = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!withoutHash || withoutHash === "/") {
    return "/";
  }
  return withoutHash.startsWith("/") ? withoutHash : `/${withoutHash}`;
}

export function parseHashRoute(hash = window.location.hash): AppRoute {
  const normalized = normalizeHash(hash);
  const [rawPath = "/", rawSearch = ""] = normalized.split("?", 2);
  return {
    path: rawPath.replace(/\/+$/, "") || "/",
    search: new URLSearchParams(rawSearch),
  };
}

export function navigate(path: string): void {
  const next = path.startsWith("/") ? path : `/${path}`;
  window.location.hash = next;
}

export function useHashRoute(): AppRoute {
  const [route, setRoute] = useState(() => parseHashRoute());

  useEffect(() => {
    const update = () => setRoute(parseHashRoute());
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);

  return route;
}
